import useFirebase from "../../../../../useFirebase";

function useCopySetting(sourceDevice, sourceDeviceData, setSourceDeviceData) {
  const {
    getCollectionData,
    postCollectionData,
    createCollectionData,
    getCollectionDataForCopySetting,
    postCollectionDataForCopySetting,
  } = useFirebase();

  function callFireStore(payload) {
    // console.log(payload);
    // postCollectionData(device, { sossettings: payload });
    // getCollectionData(device);
  }

  function handleCopyData(destinationArr) {
    const promiseArr = [];
    destinationArr?.map((item) => {
      promiseArr.push(getCollectionDataForCopySetting(item));
    });

    Promise.all([...promiseArr])
      .then((res) => {
        const formattedArr = [];
        res?.map((item) => {
          let formattedItem = { ...sourceDeviceData } || {};

          formattedItem.timesupervison = {
            ...formattedItem.timesupervison,
            allowedApps: item?.timesupervison?.allowedApps || [],
          };
          formattedItem.callAndSmsMonitoring = {
            ...formattedItem.callAndSmsMonitoring,
            contacts: item?.callAndSmsMonitoring?.contacts || [],
          };

          formattedArr.push(formattedItem);
        });
        // console.log(destinationArr, formattedArr);
        const formattedPromiseArr = [];
        formattedArr?.map((item, index) => {
          formattedPromiseArr.push(() =>
            postCollectionDataForCopySetting(destinationArr[index], item)
          );
        });
        Promise.all(formattedPromiseArr.map((promiseFn) => promiseFn()))
          .then((res) => {
            console.log(res, "all promise resolved");
          })
          .catch((err) => {
            console.log("err ==>>", err);
          });
      })
      .catch((err) => {
        console.log("err ==>>", err);
      });
  }

  return { handleCopyData };
}

export default useCopySetting;
